<template>
  <div class="modal fade fixed-right modal-add-user" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-vertical" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Agency Coordinator</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <font-awesome :icon="['fal', 'search']"/>
            </span>
          </div>

          <input v-model="debouncedSearch" type="search" class="form-control" placeholder="Search user..." />
        </div><!-- /.input-group -->

        <div class="modal-body pb-1">
          <loading-spinner v-if="fetching"/>

          <ul class="list-data">
            <li v-for="coordinator in users" :key="coordinator.id">
              <a @click="selectCoordinator(coordinator)" data-dismiss="modal">
                <p class="name text-truncate"><span>{{ coordinator.name }}</span></p>
                <p class="text-muted text-truncate">{{ coordinator.email }}</p>
                <p class="agencies text-muted text-truncate" v-if="coordinator.agencies.length > 0">
                  {{ coordinator.agencies.map(({ name }) => name).join(' / ') }}
                </p>
              </a>
            </li>
          </ul><!-- /.list-data -->

          <lazy-loading
            :loading="$loading"
            :reached-bottom="handleGetNextUsersCallback"
            scroll-target=".modal-body"
            ref="lazy">
            <loading-spinner slot="loading"/>
            <span slot="finished"></span>
          </lazy-loading>
        </div><!-- /.modal-body -->
      </div>
    </div>
  </div><!-- /.modal -->
</template>

<style scoped>
  li {
    cursor: pointer;
  }

  .list-data .agencies {
    font-size: 0.875rem;
  }
</style>

<script>
import { userMethods, userComputed, agencyComputed, agencyMethods } from 'vx/helpers'
import { debounce, findIndex } from 'lodash'

export default {
  data () {
    return {
      fetching: false,
      search: null
    }
  },

  computed: {
    ...userComputed,
    ...agencyComputed,

    debouncedSearch: {
      get () {
        return this.search
      },

      set: debounce(function (value) {
        this.search = value
      }, 1000)
    }
  },

  mounted () {
    window.$(this.$el).on('show.bs.modal', this.getInitialCoordinators)
  },

  watch: {
    async search (search) {
      this.fetching = true

      await this.getUsers({ search, role: 'coordinator' })

      this.fetching = false
    }
  },

  methods: {
    ...userMethods,
    ...agencyMethods,

    async handleGetNextUsersCallback () {
      let search = this.search
      await this.getUsersForNextPage({ search, role: 'coordinator' })

      this.$refs.lazy.$emit('reset')
    },

    /**
     * Get the initial list of coordinators when modal is shown
     */
    getInitialCoordinators () {
      this.getUsers({ role: 'coordinator' })
    },

    /**
     * If they haven't already, then add selected coordinator
     */
    async selectCoordinator (coordinator) {
      let agency = this.agency
      let index = findIndex(this.agency.coordinators, existing => existing.id === coordinator.id)

      if (index === -1) {
        await this.addCoordinator({ agency, coordinator })
        this.$noty.success('Coordinator successfully added')
      }
    }
  }

}
</script>
